/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_FinishInputs */

const en_us2_intake_finish = /** @type {(inputs: Intake_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build my plan`)
};

const pt_br2_intake_finish = /** @type {(inputs: Intake_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar meu programa`)
};

const es_419_intake_finish = /** @type {(inputs: Intake_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armar mi plan`)
};

const pt_pt2_intake_finish = /** @type {(inputs: Intake_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar o meu plano`)
};

const fr_fr2_intake_finish = /** @type {(inputs: Intake_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer mon programme`)
};

const de_de2_intake_finish = /** @type {(inputs: Intake_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meinen Plan erstellen`)
};

const it_it2_intake_finish = /** @type {(inputs: Intake_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea la mia scheda`)
};

/**
* | output |
* | --- |
* | "Build my plan" |
*
* @param {Intake_FinishInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_finish = /** @type {((inputs?: Intake_FinishInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_FinishInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_finish(inputs)
	if (locale === "es-419") return es_419_intake_finish(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_finish(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_finish(inputs)
	if (locale === "de-DE") return de_de2_intake_finish(inputs)
	if (locale === "it-IT") return it_it2_intake_finish(inputs)
	return en_us2_intake_finish(inputs)
});
export { intake_finish as "intake.finish" }